import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import MaterialTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

const styles = (theme) => ({
  cell: {
    padding: '25px 15px',
    whiteSpace: 'nowrap',
    borderWidth: '2px',
    color: theme.palette.xpl.text.secondary,
    fontSize: '12px',
    fontWeight: 'normal',
    borderBottomColor: theme.palette.xpl.stoke,
  },
  cellMobile: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
});

const TableHead = (props) => {
  const {
    onRequestSort,
    order,
    orderBy,
    rows,
    classes,
    enableSorting,
    numSelected,
    rowCount,
    checkboxSelection,
    onSelectAllClick,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <MaterialTableHead>
      <TableRow>
        {checkboxSelection && (
          <TableCell padding="checkbox" className={classes.cell}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all items' }}
            />
          </TableCell>
        )}
        {rows.map((row) => (
          <TableCell
            key={row.id}
            align={row.alignment || 'left'}
            padding={row.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === row.id ? order : false}
            className={classNames(classes.cell, {
              [classes.cellMobile]: row.hideInMobile,
            })}>
            {enableSorting ? (
              <Tooltip
                title="Sort"
                placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}>
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={createSortHandler(row.id)}>
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            ) : (
              <div>{row.label}</div>
            )}
          </TableCell>
        ))}
      </TableRow>
    </MaterialTableHead>
  );
};

TableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number.isRequired,
  enableSorting: PropTypes.bool,
  checkboxSelection: PropTypes.bool,
};

export default withStyles(styles)(TableHead);
